/* Frost — Statement Silver: tab switch (shows/hides the product group AND
   the promo tile that match the selected tab — each tab has its own
   featured tile now, not one shared across the section; the promo tile
   still lives outside the rail entirely, so it never scrolls) + two ways
   to move through the products: prev/next arrows on desktop (scroll by one
   tile, same mechanics as orizza-curated-collection.js), dot pagination on
   mobile (exactly 2 cards per view, same mechanics as the dots in
   section-frost-collection.css/frost-collection.js). Which control shows
   is pure CSS (arrows hidden, dots shown, under the same max-width:989px
   breakpoint used throughout this section) — this file drives both. */
(function () {
  function initFrostSS(section) {
    var wrap = section.querySelector('[data-frost-ss-rail-wrap]');
    var rail = section.querySelector('[data-frost-ss-rail]');
    var prevBtn = section.querySelector('[data-frost-ss-prev]');
    var nextBtn = section.querySelector('[data-frost-ss-next]');
    var pagination = section.querySelector('[data-frost-ss-pagination]');
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-frost-ss-tab]'));
    var groups = Array.prototype.slice.call(section.querySelectorAll('[data-frost-ss-group]'));
    var promos = Array.prototype.slice.call(section.querySelectorAll('[data-frost-ss-promo-group]'));
    if (!rail) return;

    // Same fix as Shop by Category / Curated Collection: forward a vertical
    // wheel gesture to the page instead of letting the horizontal rail eat it.
    rail.addEventListener(
      'wheel',
      function (event) {
        if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
          event.preventDefault();
          window.scrollBy(0, event.deltaY);
        }
      },
      { passive: false }
    );

    function visibleItems() {
      return groups.filter(function (item) { return !item.hidden; });
    }

    function tileStep() {
      var items = visibleItems();
      if (!items.length) return rail.clientWidth;
      var style = getComputedStyle(rail);
      var gap = parseFloat(style.columnGap || style.gap || 0);
      return items[0].getBoundingClientRect().width + gap;
    }

    function refreshArrows() {
      if (!prevBtn || !nextBtn || !wrap) return;
      var hasOverflow = rail.scrollWidth - rail.clientWidth > 4;
      wrap.classList.toggle('frost-ss__rail-wrap--no-overflow', !hasOverflow);
      if (!hasOverflow) return;
      prevBtn.disabled = rail.scrollLeft <= 2;
      nextBtn.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        rail.scrollBy({ left: -tileStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        rail.scrollBy({ left: tileStep(), behavior: 'smooth' });
      });
    }
    rail.addEventListener('scroll', refreshArrows, { passive: true });

    // Dots — mobile only (2 visible at a time), one per scroll position.
    var dots = [];
    var dotIndex = 0;

    function buildPagination() {
      if (!pagination) return;
      pagination.innerHTML = '';
      dots = [];
      var visibleCount = 2;
      var total = Math.max(1, visibleItems().length - visibleCount + 1);
      if (total <= 1) {
        pagination.classList.add('is-hidden');
        return;
      }
      pagination.classList.remove('is-hidden');
      for (var i = 0; i < total; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'frost-ss__page-dot';
        dot.setAttribute('aria-label', 'Go to card ' + (i + 1));
        (function (index) {
          dot.addEventListener('click', function () { goToIndex(index); });
        })(i);
        pagination.appendChild(dot);
        dots.push(dot);
      }
      updateDots();
    }

    function updateDots() {
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === dotIndex); });
    }

    function goToIndex(index) {
      var total = dots.length;
      dotIndex = Math.max(0, Math.min(index, total - 1));
      rail.scrollTo({ left: tileStep() * dotIndex, behavior: 'smooth' });
      updateDots();
    }

    var scrollTimeout;
    rail.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        var step = tileStep();
        if (!step || !dots.length) return;
        dotIndex = Math.max(0, Math.min(Math.round(rail.scrollLeft / step), dots.length - 1));
        updateDots();
      }, 100);
    }, { passive: true });

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        refreshArrows();
        buildPagination();
      }, 150);
    });

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        if (tab.classList.contains('is-active')) return;
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        groups.forEach(function (item) {
          item.hidden = item.getAttribute('data-frost-ss-group') !== String(index);
        });
        promos.forEach(function (promo) {
          promo.hidden = promo.getAttribute('data-frost-ss-promo-group') !== String(index);
        });
        rail.scrollTo({ left: 0, behavior: 'smooth' });
        dotIndex = 0;
        refreshArrows();
        buildPagination();
      });
    });

    refreshArrows();
    buildPagination();
  }

  document.querySelectorAll('[data-frost-ss-section]').forEach(initFrostSS);
})();
